import { gql, QueryHookOptions, useLazyQuery } from '@apollo/client';

export const QUERY = gql`
  query GetIndividualReportPdf($responseId: ID!) {
    getIndividualReportPdf(responseId: $responseId) {
      reportUrl
    }
  }
`;

export type Variables = {
  responseId: string;
};

export type Response = {
  readonly getIndividualReportPdf: {
    reportUrl: string;
  };
};

export const useGetIndividualReportPdfQuery = (
  options?: QueryHookOptions<Response, Variables>,
) => useLazyQuery<Response, Variables>(QUERY, options);
